import { Pipe, PipeTransform } from '@angular/core';
import { Utilities } from '../utilities';

@Pipe({
  name: 'terminationPurchasesNumber',
})
export class TerminationPurchasesNumberPipe implements PipeTransform {
  transform(value: number, text: Array<string>): string {
    if (Utilities.isNullOrUndefined(value)) {
      return '';
    }
    const sklonenie = (num, txt, cases = [2, 0, 1, 1, 1, 2]) =>
      txt[num % 100 > 4 && num % 100 < 20 ? 2 : cases[num % 10 < 5 ? num % 10 : 5]];
    return `${value} ${sklonenie(value, text)}`;
  }
}
